// Don't apply 'HeadingBuilder' for this component's 'Tippy content' ('submit' field)
import React, { useContext, useState } from 'react';
import * as Constants from '../constants';
import { ShopperContext } from '../context/shopper';
import HeadingBuilder from '../components/HeadingBuilder';
import ShowAlert from '../components/ShowAlert';
import PlanChooseRow from '../components/PlanChooseRow';
import EmailNoticeRow from '../components/EmailNoticeRow';
import { ErrorList } from './ErrorList';
import { useForm } from "../hooks/useForm";
import { useStyles } from "../hooks/useStyles";
import { StripeCircleBuyButton } from "./StripeCircleBuyButton";
import Table from 'react-bootstrap/Table';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import styles from '../css/trTdFirstChild.module.css';

const CircleSubscriptionForm = ({circle, plan_identifier, doSetFormFlag, }) => {
  const { signedIn, clientReferenceId, setClientReferenceId, editCircle,
          errorsDoExist, dismissErrorsList, setErrorsDoExistToFalse,
          setJustGotClearToFalse
        } = useContext(ShopperContext);
  const { tableShow, tableData } = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const defaultPlan = plan_identifier;
  // const defaultPlan = 'weekly3us200';
  const [whichPlan, setWhichPlan] = useState(defaultPlan);

  const [showAddCircleFormAlert, setShowAddCircleFormAlert] = useState(false);
  const toggleAddCircleFormAlert = () => {
    setShowAddCircleFormAlert(! showAddCircleFormAlert);
  }

  const [showInfoAlert, setShowInfoAlert] = useState(false);
  const toggleInfoAlert = () =>  setShowInfoAlert(! showInfoAlert);

  const initialState = {
    id: circle.id,
    plan_identifier: defaultPlan,
  };
  const { formData, handleChange, reset, editFormValues } = useForm(initialState);

  // A RadioButton shows as 'selected' when its 'isChecked' attribute is true.
  // The only RadioButton whose 'isChecked' attribute is true will be the one
  // whose 'planName' matches the value in 'whichPlan'.
  // Clicking a RadioButton runs 'setWhichPlan' with the plan's 'planName',
  // causing 'isChecked' to be true for the clicked RadioButton.

  // Note - as an event handler, handlePickPlan only activates by clicking
  // a RadioButton. Unless that happens, the 'plan_identifier' value that was
  // assigned via initialState will be what's provided upon Submit.
  // Initializing 'whichPlan' via useState(defaultPlan) does not set the form's
  // 'plan_identifier' attribute. But, by making the initial 'whichPlan' and
  // 'initialState.plan_identifier' values the same, then the "prepicked" button
  // will correctly indicate the 'plan_identifier' value configured to submit.
  const handlePickPlan = (planName) => {
    setWhichPlan(planName);  // lights up/selects that RadioButton
    handleChange({ target: {name: 'plan_identifier', value: planName} });
  };

  const goToCircles = () => {
    // Let's go back to the 'circles' page.
    // "navigate('/circles/')" makes the screen right.
    navigate('/circles/', {replace: true});

    // Refresh since the database holds the state of 'paid' for the new Circle.
    // 'payment_status' is stuck at 'pending' until there is a refresh.
    navigate(0)
  }


 if (signedIn) {
  const handleHide = (e) => {
    // Setting a value for clientReferenceId lights up the Buy Button;
    // Unsetting it makes Buy Button disappear.
    setClientReferenceId('');
    doSetFormFlag(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    dismissErrorsList();
    setErrorsDoExistToFalse();
    setJustGotClearToFalse();

    console.log('formData for adding Subscription: ', formData);

    // Need to update (maybe) which plan the circle uses
    editCircle(formData);

    // Setting a value here lights up the Buy Button:
    setClientReferenceId(circle.id);
    // 'editCircle' needs to finish (which is likely) before Shopper completes
    // their 'Subscribe' session with Stripe.
  }

  return (
    <article>
      <HeadingBuilder
        Size = "h3"
        headingText    = {t('circleSubsForm.formPart.headlineLabel')}
        // Set up new Subscription for Circle: circle.identifier
        value          = {circle.identifier}
        tippyAlertText = {t('circleSubsForm.formPart.headlineTippyContent')}
        // Use this form to set up a new Subscription, i.e. pmt arrangemt...
        tippyText      = {Constants.DOT}
      />
      <form onSubmit={handleSubmit}>
      <Table responsive striped bordered hover size="sm" style={tableShow}>
        <thead >
        </thead>
        <tbody className={styles.trTdFC} style={tableData} >
          <EmailNoticeRow />
        { circle.slots_used > 3

        ? <tr>
            <td>
              {t('circleSubsForm.slotsUsed.label')}
              {/* Shoppers and Open Invites */}
            </td>
            <td>
                  <HeadingBuilder
                    containerType = 'container-left'
                    headingText   = {circle.slots_used}
                    // e.g. 4
                    tippyText     = {Constants.DOT}
              tippyAlertText = {t('circleSubsForm.slotsUsed.valueTippyContent')}
                    // Smaller plans are available, but they are too small for your number of Shoppers and/or outstanding invitations. Reduce this count and they will appear.
                  />
            </td>
          </tr>
        : null
        }
          <PlanChooseRow
            handlePickPlan = {handlePickPlan}
            whichPlan      = {whichPlan}
            slotsUsed      = {circle.slots_used}
          />
        </tbody>
      </Table>
      { errorsDoExist && <ErrorList /> }
      <div className="oneline-container">
        <HeadingBuilder
          // heading is a stand-alone Alert button/circle for Submit
        tippyAlertText = {t('circleSubsForm.formPart.headlineTippyContent')}
        // Use this form to set up a new Subscription, i.e. pmt arrangemt...
          showTippyAlert = {showAddCircleFormAlert}
          toggleTippyAlert = {toggleAddCircleFormAlert}
        />
        <Tippy content= {t('circle.addcircle_explainer.tippyContent')} >
          <input key="200" type='submit' value='Submit' />
        </Tippy>&nbsp;
        <HeadingBuilder
          // heading is a stand-alone Info button/circle for Submit
          tippyInfoText = {t('circle.addcircle_explainer.tippyContentStripe',
    {circleOrSubscription: t('circle.addcircle_explainer.chooseSubscription')})}
// Clicking 'Submit' lets you arrange for payment. A 'Subscribe' button soon...
          showInfoAlert = {showInfoAlert}
          toggleInfoAlert = {toggleInfoAlert}
        />
      </div>
      <ShowAlert showAlert = {showAddCircleFormAlert}
                  alertMsg = {t('circle.addcircle_explainer.tippyContent')} />
      <ShowAlert showAlert = {showInfoAlert}
              alertMsg = {t('circle.addcircle_explainer.tippyContentStripe',
{circleOrSubscription: t('circle.addcircle_explainer.chooseSubscription')})} />
      </form>
      {/* <br/> */}
      {
        // If handleSubmit has caused setting a value for clientReferenceId
        // then show the associated Stripe Buy Button
        clientReferenceId.length > 0

        && <>
        <HeadingBuilder
          headingText  = {t('circle.addcircle_explainer.headingSubscribe',
{circleOrSubscription: t('circle.addcircle_explainer.youChoseSubscription')})}
      // You chose a Subscription!! Now click 'Subscribe' to arrange payment.
          tippyText    = {Constants.DOT}
        tippyAlertText = {t('circle.addcircle_explainer.tippyContentSubscribe')}
// Note: Clicking 'Subscribe' will open a tab that does not have a 'Cancel' button...
    // tippyInfoText  = {t('circle.addcircle_explainer.tippyContentSubscribeInfo')}
    tippyInfoText  = {t('circle.addcircle_explainer.tippyContentSubscribeInfo',
{hideSubscribeButtonSteps:
  t('circle.addcircle_explainer.hideSubscriptionSubscribe',
{dont_show_subscription_form_text: '['+t('circle.plan.hideSubscriptionButtonText')+']'}
   )})}
        />
        <StripeCircleBuyButton
          whichPlan = {whichPlan}
        />
        <HeadingBuilder
          Size           = 'h4'
          headingText  = {t('circle.addcircle_explainer.headingAfterSubscribe')}
          // *** After you Subscribe, click HERE to finish processing ***
          buttonAction   = {goToCircles}
          goButtonText   = {Constants.GET_ICON_RT_ARROW}
          tippyAlertText =
                    {t('circle.addcircle_explainer.tippyContentAfterSubscribe')}
          // The only thing left is to nudge your browser to refresh...
          tippyText      = {Constants.DOT}
        />
        <HeadingBuilder
          headingText    = {t('circle.plan.hideSubscriptionButtonText')}
          // Stop showing 'new Subscription' panel
          buttonAction   = {handleHide}
          goButtonText   = {Constants.GET_ICON_RT_ARROW}
          tippyAlertText = {t('circle.addcircle_hideButton.tippyContent')}
          tippyText      = {Constants.DOT}
        />
        <br/>
        </>
      }
      <hr/>
    </article>
  )

 } else {
    return (
      <HeadingBuilder
        Size = 'h3'
        headingText = {t('global.notSignedInMessage')}
        // Not Authorized - Please Sign in or Sign up
      />
    )
 }
}

export default CircleSubscriptionForm;
